import { App } from "vue";
import localforage from "localforage";

const dataStoreTitle_v1: string = 'tmi';
const dataStoreTitle_v2: string = 'tmi-prime';
const dataStoreTitle_v3: string = 'tmi-se';
const dataStoreTitle_v4: string = 'tmi-sen';
const dataStoreTitle_v5: string = 'tmi-sent';
const dataStoreTitle_v6: string = 'tmi-senti';
const dataStoreTitle_v7: string = 'tmi-sentie';
const dataStoreTitle_v8: string = 'tmi-sentien';
const dataStoreTitle_v9: string = 'sentient';
const dataStoreTitle_v10: string = 'sentient-';
const dataStoreTitle_v11: string = 'sentient-v';
const dataStoreTitle_v12: string = 'sentient-v1';
const dataStoreTitle_v13: string = 'sentient-v1.';
const dataStoreTitle_v14: string = 'sentient-v10';
const dataStoreTitle_v15: string = 'sentient-v101';
const dataStoreTitle_v16: string = 'sentient-v1010';
const dataStoreTitle_v17: string = 'sentient-v10101';
const dataStoreTitle_v18: string = 'sentient-v101010';
const dataStoreTitle_v19: string = 'sentient-v1010101';
const dataStoreTitle_v20: string = 'sentient-1010101';
const dataStoreTitle_v21: string = 'sentient-010101';
const dataStoreTitle_v22: string = 'sentient-10101';
const dataStoreTitle_v23: string = 'sentient-0101';
const dataStoreVersion: number = 1;

const currentDatabaseName = dataStoreTitle_v23;
export async function resetCurrentCachedData() {
    await localforage.dropInstance( {
        name: currentDatabaseName
    } );

    localStorage.clear();
    LocalForagePlugin.initialize();
}

let articles: LocalForage;
let authors: LocalForage;
let bonusReports: LocalForage;
let categories: LocalForage;
let courses: LocalForage;
let industrySectors: LocalForage;
let products: LocalForage;
let sectors: LocalForage;
let sectorHistory: LocalForage;
let simplePages: LocalForage;
let syncState: LocalForage;
let tags: LocalForage;
let tickers: LocalForage;
let tradeAlerts: LocalForage;
let webinars: LocalForage;

const LocalForagePlugin = {
    install( _: App< Element > ) {
        this.initialize();
    },

    initialize() {
        // Clean up the v1 'tmi' database
        localforage.dropInstance( {
            name: dataStoreTitle_v1
        } ).then();

        // Clean up the v2 'tmi_prime' database
        localforage.dropInstance( {
            name: dataStoreTitle_v2
        } ).then();

        // Clean up the v3 'tmi_se' database
        localforage.dropInstance( {
            name: dataStoreTitle_v3
        } ).then();

        // Clean up the v4 'tmi_sen' database
        localforage.dropInstance( {
            name: dataStoreTitle_v4
        } ).then();

        // Clean up the v5 'tmi_sent' database
        localforage.dropInstance( {
            name: dataStoreTitle_v5
        } ).then();

        // Clean up the v6 'tmi_senti' database
        localforage.dropInstance( {
            name: dataStoreTitle_v6
        } ).then();

        // Clean up the v7 'tmi_sentie' database
        localforage.dropInstance( {
            name: dataStoreTitle_v7
        } ).then();

        // Clean up the v8 'tmi_sentien' database
        localforage.dropInstance( {
            name: dataStoreTitle_v8
        } ).then();

        // Clean up the v9 'sentient' database
        localforage.dropInstance( {
            name: dataStoreTitle_v9
        } ).then();

        // Clean up the v10 'sentient-' database
        localforage.dropInstance( {
            name: dataStoreTitle_v10
        } ).then();

        // Clean up the v11 'sentient-v' database
        localforage.dropInstance( {
            name: dataStoreTitle_v11
        } ).then();

        // Clean up the v12 'sentient-v1' database
        localforage.dropInstance( {
            name: dataStoreTitle_v12
        } ).then();

        // Clean up the v13 'sentient-v1.' database
        localforage.dropInstance( {
            name: dataStoreTitle_v13
        } ).then();

        // Clean up the v14 'sentient-v10' database
        localforage.dropInstance( {
            name: dataStoreTitle_v14
        } ).then();

        // Clean up the v15 'sentient-v101' database
        localforage.dropInstance( {
            name: dataStoreTitle_v15
        } ).then();

        // Clean up the v16 'sentient-v1010' database
        localforage.dropInstance( {
            name: dataStoreTitle_v16
        } ).then();

        // Clean up the v17 'sentient-v10101' database
        localforage.dropInstance( {
            name: dataStoreTitle_v17
        } ).then();

        // Clean up the v18 'sentient-v101010' database
        localforage.dropInstance( {
            name: dataStoreTitle_v18
        } ).then();

        // Clean up the v19 'sentient-v1010101' database
        localforage.dropInstance( {
            name: dataStoreTitle_v19
        } ).then();

        // Clean up the v20 'sentient-1010101' database
        localforage.dropInstance( {
            name: dataStoreTitle_v20
        } ).then();

        // Clean up the v21 'sentient-010101' database
        localforage.dropInstance( {
            name: dataStoreTitle_v21
        } ).then();

        // Clean up the v22 'sentient-10101' database
        localforage.dropInstance( {
            name: dataStoreTitle_v22
        } ).then();

        articles = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'articles', // Should be alphanumeric, with underscores.
            description: 'The collection of all subscription-based articles'
        } );
        articles.ready().then();

        authors = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'authors', // Should be alphanumeric, with underscores.
            description: 'The collection of all authors'
        } );
        authors.ready().then();

        bonusReports = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'reports', // Should be alphanumeric, with underscores.
            description: 'The collection of all product-based bonus reports'
        } );
        bonusReports.ready().then();

        categories = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'categories', // Should be alphanumeric, with underscores.
            description: 'The collection of all categories'
        } );
        categories.ready().then();

        courses = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'courses', // Should be alphanumeric, with underscores.
            description: 'The collection of all educational courses'
        } );
        courses.ready().then();

        industrySectors = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'industry', // Should be alphanumeric, with underscores.
            description: 'The collection of all industry sectors'
        } );
        industrySectors.ready().then();

        products = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'products', // Should be alphanumeric, with underscores.
            description: 'The collection of all defined product offerings'
        } );
        products.ready().then();

        sectors = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'sectors', // Should be alphanumeric, with underscores.
            description: 'The collection of all configured sectors'
        } );
        sectors.ready().then();

        sectorHistory = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'history', // Should be alphanumeric, with underscores.
            description: 'The collection of all sector stats'
        } );
        sectorHistory.ready().then();

        simplePages = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'pages', // Should be alphanumeric, with underscores.
            description: 'The collection of all non-interactive html page content items'
        } );
        simplePages.ready().then();

        syncState = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'sync_state', // Should be alphanumeric, with underscores.
            description: 'The collection of all current syncing metrics'
        } );
        syncState.ready().then();

        tags = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'tags', // Should be alphanumeric, with underscores.
            description: 'The collection of all tags'
        } );
        tags.ready().then();

        tickers = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'tickers', // Should be alphanumeric, with underscores.
            description: 'The collection of all searchable tickers'
        } );
        tickers.ready().then();

        tradeAlerts = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'alerts', // Should be alphanumeric, with underscores.
            description: 'The collection of all trade alerts authorized for user'
        } );
        tradeAlerts.ready().then();

        webinars = localforage.createInstance( {
            driver: localforage.INDEXEDDB,
            name: currentDatabaseName,
            version: dataStoreVersion,
            storeName: 'webinars', // Should be alphanumeric, with underscores.
            description: 'The collection of all webinars authorized for user'
        } );
        webinars.ready().then();
    }
}

export default LocalForagePlugin;
export {
    articles,
    authors,
    bonusReports,
    categories,
    courses,
    industrySectors,
    products,
    sectors,
    sectorHistory,
    simplePages,
    syncState,
    tags,
    tickers,
    tradeAlerts,
    webinars
};
